import { createRouter, createWebHistory } from 'vue-router'
import EmailView from '../views/EmailView.vue'
import { useAuthStore } from '@/stores/authStore'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // ========================================
    // Direct Game Access Routes (New System)
    // ========================================
    {
      path: '/games/cards',
      name: 'cards-game',
      component: () => import('../views/games/CardsGameView.vue'),
      meta: {
        title: 'Memory Cards Game',
        iframeCompatible: true,
        requiresAuth: true, // [A009] Authentication required - enforced by AuthGuard component
      },
    },
    {
      path: '/games/treasure',
      name: 'treasure-game',
      component: () => import('../views/games/TreasureGameView.vue'),
      meta: {
        title: 'Treasure Hunt Game',
        iframeCompatible: true,
        requiresAuth: true, // [A009] Authentication required - enforced by AuthGuard component
      },
    },
    {
      path: '/games/numbers',
      name: 'numbers-game',
      component: () => import('../views/games/NumbersGameView.vue'),
      meta: {
        title: 'Numbers Game',
        iframeCompatible: true,
        requiresAuth: true, // [T007] Authentication required - enforced by AuthGuard component
      },
    },

    // ========================================
    // Legacy Routes (Will be removed)
    // ========================================
    {
      path: '/',
      name: 'email',
      component: EmailView,
      meta: {
        title: 'Enter Email',
        legacy: true,
      },
    },
    {
      path: '/game/:gameName',
      name: 'game',
      component: () => import('../views/GameView.vue'),
      meta: {
        title: 'Play Game',
        legacy: true,
      },
    },
    {
      path: '/complete',
      name: 'complete',
      component: () => import('../views/CompleteView.vue'),
      meta: {
        title: 'Game Complete',
        legacy: true,
      },
    },
  ],
})

// Navigation guard for page titles and authentication
router.beforeEach((to, _from, next) => {
  // Set page title from route meta
  const title = to.meta.title as string | undefined
  if (title) {
    document.title = `${title} | Web Games`
  }

  // [A009] Authentication guard for protected routes
  // Note: This is a basic check. AuthGuard component provides the full authentication flow.
  // The router guard is kept simple to avoid blocking navigation during authentication initialization.
  if (to.meta.requiresAuth) {
    const authStore = useAuthStore()

    // Allow navigation if:
    // 1. Already authenticated
    // 2. Currently authenticating (let AuthGuard handle it)
    // 3. Has URL parameters that might contain auth data
    const hasAuthParams = to.query.userId || to.query.email
    const canProceed = authStore.isAuthenticated || authStore.isAuthenticating || hasAuthParams

    if (!canProceed && !authStore.authError) {
      // Only block if definitely not authenticated and no auth params
      // In practice, AuthGuard will show appropriate message
      console.warn('[Router] Access to protected route without authentication')
    }
  }

  next()
})

export default router
